import { FC } from "react";
import { SafeHtml } from "../../../utilities/safeHtml";
export const HeroHeader: FC<{ copy: string }> = ({ copy }) => {
  return (
    <div className="px-6 py-8 bg-white sm:py-24 lg:px-8">
      <div className="max-w-2xl mx-auto text-center">
        <span
          className={` inline-flex items-center rounded-full px-3 py-0.5 text-sm font-medium bg-primary-50`}
        >
          <p className={`text-primary-910 text-lg font-semibold`}>Careers</p>
        </span>
        <SafeHtml html={copy} />
      </div>
    </div>
  );
};

export const HeroImage = () => {
  return (
    <>
      <img
        src="https://source.unsplash.com/g1Kr4Ozfoac"
        className="object-cover w-full h-96"
        alt={"alt"}
      />
    </>
  );
};

// text-primary-910 text-lg
